import { render, staticRenderFns } from "./selectAccordion.vue?vue&type=template&id=4eaabb5a&scoped=true&"
import script from "./selectAccordion.vue?vue&type=script&lang=js&"
export * from "./selectAccordion.vue?vue&type=script&lang=js&"
import style0 from "./selectAccordion.vue?vue&type=style&index=0&id=4eaabb5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eaabb5a",
  null
  
)

export default component.exports